<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    localChartData: null
  }),
  methods: {
    updateChart () {
      this.$data._chart.update()
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      handler: function () {
        this.renderChart(this.chartData, this.options)
      },
      deep: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// BarChart.vue?4ee9ec37